













































































































import { Component, Vue } from 'vue-property-decorator';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { changeLoading } from '@/util/plugins';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const getUrl = require('baimahu/url-with-param');
const API = {
  add: `${FCAPI}/shang/ruan/cases`,
  get_detail: `${FCAPI}/shang/ruan/cases/`,
  get_list: `${FCAPI}/shang/ruan/style`,
};
const MAX_LENGTH = 12;
const UPLOAD_DIR = {
  list_image: 'list_image',
  detail: 'detail',
};
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

// interface 接口定义 用来检测数据类型
interface Form {
  name: string;
  city: string;
  list_img_url: string;
  unit_img_url: [];
}

// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入名称',
    },
    {
      field: 'style_id',
      validate: (value: string): boolean => !!value,
      message: '请选择风格',
    },
    {
      field: 'list_image',
      validate: (value: string): boolean => !!value,
      message: '请选择列表图',
    },
    {
      field: 'detail_image',
      validate: (value: string): boolean => value.length > 0,
      message: '请选择详情图',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}
function initStyleList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
const TAG_MAX_LENGTH = 4;
function initFormValue(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    tag: remote.tag || [],
    style_id: remote.style_id || undefined,
    list_image: remote.list_image || '',
    detail_image: remote.detail_image || [],
    tag_name: '',
  };
}
@Component({
  components: {
    MultipleImageUpload,
    SingleImageUpload,
  },
})
export default class AddDesignWorks extends Vue {
  is_loading: boolean = false;
  is_edit: boolean = false;
  form_layout: any = {
    labelCol: { span: 2 },
    wrapperCol: { span: 15 },
  };
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  is_show_image_modal: boolean = false;
  form: any = initFormValue();
  modal_image_src: string = '';
  style_list: any = initStyleList();
  get uploadDir() {
    return UPLOAD_DIR;
  }
  get maxLength() {
    return MAX_LENGTH;
  }
  get tagMaxLength() {
    return TAG_MAX_LENGTH;
  }
  handlePreview(imageUrl: string) {
    this.modal_image_src = imageUrl;
    this.is_show_image_modal = true;
  }

  // 判断是否有必选项没有填
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    return is_valid;
  }

  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  detailBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 删除标签
  deleteTage(index: number) {
    this.form.tag.splice(index, 1);
  }

  // 点击提交按钮
  @changeLoading(['is_loading'])
  async submit() {
    if (!this.validateCommit()) {
      return;
    }
    const data = this.form;
    let res;
    if (this.$route.query.id) {
      res = await this.$axios.put(`${API.add}/${this.$route.query.id}`, {
        id: this.$route.query.id,
        name: data.name,
        tag: data.tag.join(','),
        style_id: data.style_id,
        list_image: data.list_image,
        detail_image: data.detail_image.join(','),
      });
    } else {
      res = await this.$axios.post(API.add, {
        name: data.name,
        tag: data.tag.join(','),
        style_id: data.style_id,
        list_image: data.list_image,
        detail_image: data.detail_image.join(','),
      });
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$router.go(-1);
    this.$message.success(this.$route.query.id ? '编辑成功' : '新增成功');
  }

  // 添加标签
  addTag() {
    if (this.form.tag.length >= 4) {
      this.$message.error('最多添加4条标签');
      return;
    }
    if (this.form.tag_name) {
      this.form.tag.push(this.form.tag_name);
    } else {
      this.$message.error('请输入标签名');
      return;
    }
    this.form.tag_name = '';
  }

  // 获取风格列表
  @changeLoading(['is_loading'])
  async getStyleList(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.style_list = initStyleList(res.data.data);
  }

  // 获取详情
  @changeLoading(['is_loading'])
  async getDetail() {
    const url = getUrl(`${API.get_detail}${this.$route.query.id}`, {
      id: this.$route.query.id,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.form = initFormValue(res.data.data);
    this.form.tag = res.data.data.tag ? res.data.data.tag.split(',') : [];
    this.form.detail_image = res.data.data.detail_image.split(',');
  }

  @changeLoading(['is_loading'])
  async created() {
    if (this.$route.query.id) {
      this.is_edit = true;
      await this.getDetail();
    }
    await this.getStyleList();
  }
}
